import { render } from "./ServicesAccelere.vue?vue&type=template&id=c8aa2f9c&scoped=true"
import script from "./ServicesAccelere.vue?vue&type=script&lang=js"
export * from "./ServicesAccelere.vue?vue&type=script&lang=js"

import "./ServicesAccelere.vue?vue&type=style&index=0&id=c8aa2f9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8aa2f9c"]])

export default __exports__